module.exports = __webpack_public_path__ + "img/transaction.73209f96.svg";